import { render, staticRenderFns } from "./optimiserUnallocPanelsDialog.vue?vue&type=template&id=275a2d96&scoped=true&"
import script from "./optimiserUnallocPanelsDialog.vue?vue&type=script&lang=js&"
export * from "./optimiserUnallocPanelsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a2d96",
  null
  
)

export default component.exports